import React from "react";
import CustomAvatar from "../../../../../../avatar/Avatar";
import { useByStudent } from "../../ByStudentContext/ByStudentContext";
import DialogStudentSelector from "./Dialog";
import TextEllipsis from "../../../../../../text/TextEllipsis";
import { useSelector } from "react-redux";

const StudentSelector = () => {
  const user = useSelector(state => state?.session?.user || {});
  const licenses = useSelector(state => state?.tenant?.license || []);
  const checkAssessment = licenses?.some((license) => license._id === '61fc0f1d6bbfcac1a18f02ba');
  const { setStudentSelected, studentSelected } = useByStudent();
  const [dialog, setDialog] = React.useState(false);

  return (
    <>
      <div
        className="min-w-150px max-w-150px flex gap-2 items-center bg-clickeabled px-2 cursor-pointer"
        size="small"
        style={{ padding: "0.5rem 0.5rem" }}
        onClick={
          checkAssessment 
          ? user.roles.some((role) => !["Student", "Parent"].includes(role.id)) ? () => setDialog(true) : null
          : user.roles.some((role) => !["Student"].includes(role.id)) ? () => setDialog(true) : undefined}
      >
        <CustomAvatar 
          size="small" 
          variant={"rounded"}
          alt={studentSelected?.code}
          src={studentSelected ? `photos/${studentSelected?.photo}` : null}
        />
        { studentSelected ? 
          <div className=" overflow-hidden">
            <TextEllipsis className=" text-primary">{studentSelected?.code}</TextEllipsis>
            <TextEllipsis className="text-sm">{studentSelected?.fullName}</TextEllipsis>
          </div>:
          <span className="text-sm">Select a student</span>
        }
      </div>
      { dialog && (
        <DialogStudentSelector
          open={dialog}
          onClose={() => setDialog(false)}
          userId={studentSelected?._id}
          onApply={(student) => setStudentSelected(student)}
        />
      )}
    </>
  );
};

export default StudentSelector;
